<div class="newsletter">
  <div class="newsletter-header">
    <div class="newsletter-header-title">Melde dich zum Newsletter an!</div>
    <div class="newsletter-header-subtitle">
      Bleib immer up-to-date und hol dir wertvolle Infos rund um evidenzbasierte
      Therapie und praxisnahe Tipps zur Umsetzung! InWi versorgt dich regelmäßig
      mit den neuesten exklusiven Angeboten.
    </div>
  </div>

  <form
    class="newsletter-form"
    [formGroup]="newsletterForm"
    (ngSubmit)="subscribeToNewsletter()">
    <div class="newsletter-name-row">
      <div class="input-simple">
        <input
          type="text"
          class="input-field"
          id="firstname"
          formControlName="firstname"
          placeholder="Vorname"
          autocomplete="given-name" />
        <app-error-message
          [formField]="newsletterForm.get('firstname')"></app-error-message>
      </div>
      <div class="input-simple">
        <input
          type="text"
          class="input-field"
          id="lastname"
          formControlName="lastname"
          placeholder="Nachname"
          autocomplete="family-name" />
        <app-error-message
          [formField]="newsletterForm.get('lastname')"></app-error-message>
      </div>
    </div>
    <div class="input-simple newsletter-email-row">
      <input
        type="email"
        class="input-field"
        id="email"
        formControlName="email"
        placeholder="E-Mail"
        autocomplete="on" />
      <!-- Error Messages -->
      <app-error-message
        [formField]="newsletterForm.get('email')"></app-error-message>
    </div>
    <button
      type="submit"
      class="inwi-text-button-large-primary"
      [disabled]="isLoading || isSubscribed">
      <div class="button-content">
        <div class="button-text">
          {{ isSubscribed ? 'Bereits angemeldet' : 'Jetzt abonnieren' }}
        </div>
      </div>
    </button>
  </form>
</div>
